var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseMark = function SvgCloseMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.756 5.121a1.331 1.331 0 0 0-1.882-1.882L9.5 7.62 5.12 3.243a1.331 1.331 0 0 0-1.882 1.881L7.618 9.5l-4.375 4.379a1.331 1.331 0 0 0 1.882 1.882L9.5 11.38l4.378 4.375a1.332 1.332 0 0 0 1.882-1.882L11.382 9.5l4.374-4.379Z",
    fill: "#fff"
  })));
};
export default SvgCloseMark;